module.exports = __webpack_public_path__ + "img/home-delivery.59771931.jpg";